export enum QuoteTableRowKey {
  DATE = 'date',
  STATUS = 'status',
  PRODUCT = 'product',
  OWNER = 'owner',
  SUPPORT = 'support',
  INSUREDS = 'insureds',
  QUOTE_IDENTIFIER = 'quoteIdentifier',
  CLIENT_PRICE = 'clientPrice',
  RISK_ID = 'riskId',
  UNREAD_NOTIFICATION_COUNT = 'unreadNotificationCount',
}
